import { useEffect, useState } from "react";
import {
  filter,
  find,
  map,
  toUpper,
  isEmpty,
  propEq,
  path,
  length,
  addIndex,
  pathEq
} from "ramda";
import { useIntl } from "react-intl";
import common from "@/i18n/definitions/common";
import education from "@/i18n/definitions/education";
import Typography from "@mui/material/Typography";
import { getRajoitteetFromMaarays } from "@/utils/rajoitteetUtils";
import LisatiedotHtmlLupa from "./Lisatiedot";
import rajoitteet from "@/i18n/definitions/rajoitteet";
import { PropTypes } from "prop-types";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";
import { sortByLocale } from "@/helpers/html";

export default function Opetuskielet({ maaraykset }) {
  const intl = useIntl();
  const locale = toUpper(intl.locale);
  const [kieletOPH, setKieletOPH] = useState([]);

  /** Fetch kieletOPH from storage */
  useEffect(() => {
    localForage
      .getItem(PaikallisenTietovarastonAvain.KIELET_OPH)
      .then(kielet => setKieletOPH(kielet))
      .catch(err => {
        console.error(err);
      });
  }, []);

  const ensisijaisetOpetuskielet = sortByLocale(
    locale,
    filter(
      maarays =>
        pathEq(["kohde", "tunniste"], "opetuskieli", maarays) &&
        maarays.koodisto === "kielikoodistoopetushallinto" &&
        pathEq(["meta", "valikko"], "ensisijaiset", maarays),
      maaraykset
    )
  );

  const toissijaisetOpetuskielet = sortByLocale(
    locale,
    filter(
      maarays =>
        pathEq(["kohde", "tunniste"], "opetuskieli", maarays) &&
        maarays.koodisto === "kielikoodistoopetushallinto" &&
        pathEq(["meta", "valikko"], "toissijaiset", maarays),
      maaraykset
    )
  );

  const lisatietomaarays = find(
    maarays =>
      pathEq(["kohde", "tunniste"], "opetuskieli", maarays) &&
      maarays.koodisto === "lisatietoja",
    maaraykset
  );

  return (
    (!isEmpty(ensisijaisetOpetuskielet) ||
      !isEmpty(toissijaisetOpetuskielet)) &&
    !isEmpty(kieletOPH) && (
      <div className="mt-4">
        <Typography component="h3" variant="h3">
          {intl.formatMessage(common.opetuskieli)}
        </Typography>
        {getOpetuskieletHtml(ensisijaisetOpetuskielet, kieletOPH, locale, intl)}
        {!isEmpty(toissijaisetOpetuskielet) && (
          <Typography component="h4" variant="h4">
            {intl.formatMessage(education.voidaanAntaaMyosSeuraavillaKielilla)}
          </Typography>
        )}
        {getOpetuskieletHtml(toissijaisetOpetuskielet, kieletOPH, locale, intl)}
        <LisatiedotHtmlLupa lisatietomaarays={lisatietomaarays} />
      </div>
    )
  );
}

Opetuskielet.propTypes = {
  maaraykset: PropTypes.array
};

const getOpetuskieletHtml = (opetuskielet, kieletOPH, locale, intl) => {
  return (
    <ul className="ml-8 list-disc mb-4">
      {addIndex(map)(
        (opetuskieli, index) => [
          <li
            key={opetuskieli.koodiarvo}
            className={`leading-bulletList ${
              length(opetuskieli.aliMaaraykset) ? "mb-2" : ""
            }`}>
            {path(
              ["metadata", locale, "nimi"],
              find(
                propEq("koodiarvo", toUpper(opetuskieli.koodiarvo)),
                kieletOPH
              )
            )}
            <div key={"div-" + index}>
              {length(opetuskieli.aliMaaraykset)
                ? getRajoitteetFromMaarays(
                    opetuskieli.aliMaaraykset,
                    locale,
                    intl.formatMessage(rajoitteet.ajalla)
                  )
                : ""}
            </div>
          </li>
        ],
        opetuskielet || []
      )}
    </ul>
  );
};
